const api = "http://94.183.250.121:8021/api/";
// const api = "http://31.25.93.49:8024/api/";
// const api  = 'http://websla.ir/api/'

export { api };
